import React, { useMemo } from "react";
import {
  SubTitleTab,
  TitleTab,
} from "../../../../../../component/page-components";
import { Col, Input, Row, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import MSSDisplayDayOff from "../../../../../../component/mss/day-off/display-day-off";

const FormAddressOwned = ({ form }) => {
  const shiftStartHours = useMemo(() => {
    if (
      !form?.shift_start ||
      form?.shift_start === "" ||
      form?.shift_start === null
    ) {
      return "00";
    }
    const hours = form?.shift_start.split(":");
    return hours[0];
  }, [form?.shift_start]);

  const shiftStartMinutes = useMemo(() => {
    if (
      !form?.shift_start ||
      form?.shift_start === "" ||
      form?.shift_start === null
    ) {
      return "00";
    }
    const hours = form?.shift_start.split(":");
    return hours[1];
  }, [form?.shift_start]);

  const shiftEndHours = useMemo(() => {
    if (
      !form?.shift_end ||
      form?.shift_end === "" ||
      form?.shift_end === null
    ) {
      return "00";
    }
    const hours = form?.shift_end.split(":");
    return hours[0];
  }, [form?.shift_end]);

  const shiftEndMinutes = useMemo(() => {
    if (
      !form?.shift_end ||
      form?.shift_end === "" ||
      form?.shift_end === null
    ) {
      return "00";
    }
    const hours = form?.shift_end.split(":");
    return hours[1];
  }, [form?.shift_end]);

  return (
    <div className="columns">
      <TitleTab title="Address" />

      <div className="container-field">
        <SubTitleTab title="Country" />
        <Select

          size="large"
          value={form?.country_id}
          options={[{ label: form?.country, value: form?.country_id }]}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Province" />
        <Select

          size="large"
          value={form?.province_id}
          options={[{ label: form?.province, value: form?.province_id }]}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="District" />
        <Select
          size="large"
          value={form?.district_id}
          options={[{ label: form?.district, value: form?.district_id }]}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Sub District" />
        <Select
          size="large"
          value={form?.sub_district_id}
          options={[{ label: form?.sub_district, value: form?.sub_district_id }]}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Urban Village" />
        <Select
          size="large"
          value={form?.urban_village_id}
          options={[
            { label: form?.urban_village, value: form?.urban_village_id },
          ]}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Address" />
        <TextArea
          style={{ width: "67%", resize: "none" }}
          size="large"
          rows={4}
          maxLength={100}
          disabled
          value={form?.address ? form?.address : "-"}
        />
      </div>

      <Row >
        <Col span={8} className="pr-2 ">
          <div className="container-field">
            <SubTitleTab title="Neighbourhood (Optional)" />
            <Input
              size="large"
              disabled
              value={form?.neighbourhood ? form?.neighbourhood : "-"}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="container-field">
            <SubTitleTab title="Hamlet (Optional)" />
            <Input
              size="large"
              disabled
              value={form?.hamlet ? form?.hamlet : "-"}
            />
          </div>
        </Col>
        <Col span={8}></Col>
      </Row>

      <div className="container-field">
        <SubTitleTab title="Postal Code" />
        <Select
          size="large"
          value={form?.postal_code_id}
          options={[{ label: form?.postal_code, value: form?.postal_code_id }]}
          disabled
        />
      </div>

      <TitleTab title="Working Hours" />

      <div className="container-field">
        <SubTitleTab title="Shift Start" />
        <div className=" w-2/6 h-[47px]">
          <Row>
            <Col span={10} className="pr-2 ">
              <Input
                style={{ height: "47px" }}
                disabled
                value={shiftStartHours}
              />
            </Col>
            <Col>
              <p className="mr-1 text-2xl font-bold font-roboto text-black-100">
                :
              </p>
            </Col>
            <Col span={10}>
              <Input
                style={{ height: "47px" }}
                disabled
                value={shiftStartMinutes}
              />
            </Col>
          </Row>
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Shift End" />
        <div className=" w-2/6 h-[47px]">
          <Row>
            <Col span={10} className="pr-2 ">
              <Input style={{ height: "47px" }} disabled value={shiftEndHours} />
            </Col>
            <Col>
              <p className="mr-1 text-2xl font-bold font-roboto text-black-100">
                :
              </p>
            </Col>
            <Col span={10}>
              <Input
                style={{ height: "47px" }}
                disabled
                value={shiftEndMinutes}
              />
            </Col>
          </Row>
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Day Off" />
        <MSSDisplayDayOff listDayOff={form?.day_off} disabled />
      </div>
      
      <div className="container-field">
        <SubTitleTab title="Daily Salary" />
        <Input
          addonBefore="IDR"
          size="large"
          value={form?.salary}
          disabled
        />
      </div>
      <div className="container-field">
        <SubTitleTab title="Hourly Salary" />
        <Input
          addonBefore="IDR"
          size="large"
          value={form?.salary_per_hour}
          disabled
        />
      </div>
    </div>
  );
};

export default FormAddressOwned;
